import { html2text } from 'dygc'

function transformShareUrl(answerId, userId, companyid) {
  const url = window.location.href.split('#')[0]
  let link = url
    .replace('&redirect=1', '')
    .replace(/\??&?token=[^&]*/, '')
    .replace(/\??&?accountUserId=[^&]*/, '')
    .replace(/\??&?shareAccountUserId=[^&]*/, '')
    .replace(/\??&?shareAnswerId=[^&]*/, '')

  if (answerId) {
    link = link + '&shareAnswerId=' + answerId
  }
  if (userId) {
    link = link + '&shareAccountUserId=' + userId
  }
  if (companyid && !link.includes('companyid')) {
    link = link + '&companyid=' + companyid
  }
  return link
}

export function registerShare(options, answerId, userId, trigger) {
  let { title, desc, icon, link, imgUrl, originTitle } = options
  desc = html2text(desc)
  title = html2text(title)
  if (!link) {
    link = transformShareUrl(answerId, userId)
  } else {
    link = link.replace('&redirect=1', '').replace(/\??&?token=[^&]*/, '')
  }
  link = link.split('#')[0]
  const newApi = ['updateAppMessageShareData', 'updateTimelineShareData']
  const oldApi = ['onMenuShareTimeline', 'onMenuShareAppMessage']
  newApi.forEach(shareInfo => {
    if (wx[shareInfo]) {
      wx[shareInfo]({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link,
        imgUrl: imgUrl || icon || window.location.origin + '/assets/img/logo/link-icon.png', // 分享图标
        success: function () {
          // alert(window.location.href)
          // alert(link)
          // alert(title + desc)
          // alert('success')
          // success && success()
          trigger && trigger()
        },
        trigger: function () {
          trigger && trigger()
        },
        fail(err) {
          // alert('fail')
          // alert(JSON.stringify(err))
        }
      })
    }
  })
}
